import React from 'react';

import { Action, Actions, DeleteIcon } from '@gogame/components';
import Permissions from '@gogame/permissions';

import { ACTION_DELETE } from 'scenes/Users/AdminUsers/Departments/constants';

export default ({ actions, onDelete }) => (
  <Permissions actions={actions}>
    {({ isActionAllowed }) => (
      <Actions>
        <Action
          id={ACTION_DELETE}
          icon={<DeleteIcon />}
          label={'Delete'}
          disabled={!isActionAllowed(ACTION_DELETE)}
          onClick={onDelete}
        />
      </Actions>
    )}
  </Permissions>
);
